window.isElementVisible = function (row, container) {
    if ($(row).length) {
        var elementTop = $(row).offset().top,
            elementHeight = $(row).height(),
            containerTop = container.scrollTop(),
            containerHeight = container.height();

        return ((((elementTop - containerTop) + elementHeight) > 0) && ((elementTop - containerTop) < containerHeight));
    } else {
        return false
    }
}
window.alertMessage = function (theme = 'cyan', icon = 'check-circle', content = '', target = false) {
    if (!target) {
        target = $('#content');
    }
    target.before('<div class="alert alert-' + theme + ' alert-dismissible fw-semibold fs-16 fade show" role="alert"><i class="fa fa-' + icon + '"></i> ' + content + ' <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button></div>');
}
window.customAjaxRequest = function (url, method = 'get', data = [], fnBefore = null, fnAfter = null) {
    $.ajax({
        url: url,
        type: method,
        data: data,
        dataType: 'json',
        success: function (json) {
            if (fnBefore) {
                fnBefore(json);
            }

            if (fnAfter) {
                fnAfter(json);
            } else {
                if (json['redirect']) {
                    location = json['redirect'] + '?goTo=' + encodeURIComponent(window.location.href);
                }
                if (json['success']) {
                    alertMessage('cyan', 'check-circle', json['success'])
                }

                if (json['popup']) {
                    $('footer').before(json['popup']);
                }
            }
        },
        error: function (xhr, ajaxOptions, thrownError) {
            alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
        }
    });
}
window.copyLink = function (button) {
    const tooltip = bootstrap.Tooltip.getInstance('#' + button.attr('id'));
    const originalTooltip = button.data('bs-title');
    navigator.clipboard.writeText(button.data('link'));
    tooltip.setContent({ '.tooltip-inner': button.data('title-copied') });

    setTimeout(function () {
        tooltip.setContent({ '.tooltip-inner': originalTooltip });
    }, 3000);
}
window.closeDropdown = function () {
    $('.show[data-bs-toggle="dropdown"]').each(function () {
        const dd = bootstrap.Dropdown.getInstance(this);
        dd.hide();
    });
}
window.megaMenu = function () {
    const mainMenu = document.getElementById('mainMenu')
    const blackMenu = $('#mainMenu > .bg-black');
    if ($(window).width() >= 992) {
        $(window).scroll(function () {
            closeDropdown();
            if ($(window).scrollTop() > 130) {
                blackMenu.addClass('position-fixed').addClass('top-0');
            } else {
                blackMenu.removeClass('position-fixed').removeClass('top-0');
            }
        });
        $('.has-megamenu > .nav-link[data-bs-toggle="dropdown"]').click(function (e) {
            location = $(this).attr('href');
        });

        $('.nav-link[data-bs-toggle="dropdown"]').hover(function (e) {
            closeDropdown();
            const dd = bootstrap.Dropdown.getInstance(this);
            dd.show();
        }, function (e) {
            if (!$(e.relatedTarget).hasClass('megamenu')) {
                closeDropdown();
            }
        });

        $('.dropdown-menu.megamenu').hover(function (e) {
        }, function (e) {
            if (!$(e.relatedTarget).hasClass('.nav-link')) {
                closeDropdown();
            }
        });
    } else {
        const headerHeight = $('.navbar-brand').outerHeight() + 24;
        mainMenu.style.top = headerHeight + 'px';

        mainMenu.addEventListener('show.bs.collapse', event => {
            $('body').addClass('menu-opened');
        });
        mainMenu.addEventListener('hide.bs.collapse', event => {
            const openedMegaMenuToggle = $('.megamenu-opened [data-bs-toggle="dropdown"]');
            if (openedMegaMenuToggle.length) {
                const dd = bootstrap.Dropdown.getInstance(openedMegaMenuToggle)
                dd.hide();
            }
            $('body').removeClass('menu-opened');
        });

        $(mainMenu).click(function (e) {
            if ($(e.target).attr('id') === 'mainMenu') {
                const cc = bootstrap.Collapse.getInstance(mainMenu)
                cc.hide();
            }
        })
        $('.has-megamenu [data-bs-toggle="dropdown"]').each(function () {
            this.addEventListener('show.bs.dropdown', event => {
                $(this).parent().addClass('megamenu-opened');
                $('body').addClass('sub-menu-opened');
            });
        })
        $('.has-megamenu [data-bs-toggle="dropdown"]').each(function () {
            this.addEventListener('hide.bs.dropdown', event => {
                $('.sub-megamenu-opened').click();
                $(this).parent().removeClass('megamenu-opened');
                $('body').removeClass('sub-menu-opened');
            });
        })

        $('.has-sub-megamenu').click(function () {
            if ($(this).hasClass('sub-megamenu-opened')) {
                $(this).removeClass('sub-megamenu-opened');
                $(this).parents('.megamenu-opened').removeClass('has-sub-megamenu-opened');
            } else {
                $(this).addClass('sub-megamenu-opened');
                $(this).parents('.megamenu-opened').addClass('has-sub-megamenu-opened');
            }
        })
    }
}
window.footerMenu = function () {
    if ($(window).width() < 576) {
        $('footer .h3.d-flex').click(function () {
            const icon = $(this).find('i');
            if (icon.hasClass('fa-chevron-down')) {
                icon.removeClass('fa-chevron-down').addClass('fa-chevron-up');
            } else {
                icon.removeClass('fa-chevron-up').addClass('fa-chevron-down');
            }
            $(this).next().slideToggle();
        });
    }
}
window.mobileColumnLeft = function () {
    if ($(window).width() < 992) {
        const columnLeft = document.getElementById('column-left');
        if (document.body.getAttribute('class').indexOf('account-') !== -1) {
            $(columnLeft).removeClass('d-none');
        } else {
            $('#columnLeftToggle').click(function () {
                if ($('body').hasClass('filter-opened')) {
                    $(columnLeft).addClass('d-none');
                    $('body').removeClass('filter-opened');
                } else {
                    $(columnLeft).removeClass('d-none');
                    $('body').addClass('filter-opened');
                }
            });

            $(columnLeft).click(function (e) {
                if ($(e.target).attr('id') === 'column-left') {
                    $('#columnLeftToggle').click();
                }
            })
            $("#closeLeftColumn").click(function (e) {
                $('#columnLeftToggle').click();
            })
        }
    }
}
window.cartUpdate = function (key, quantity = 1) {
    if (quantity > 0) {
        customAjaxRequest('index.php?route=checkout/cart/edit', 'post', 'quantity[' + key + ']=' + quantity, null, function (json) {
            location.reload();
        })
    } else {
        customAjaxRequest('index.php?route=checkout/cart/remove', 'post', 'key=' + key, null, function (json) {
            location.reload();
        })
    }
}
window.couponRemove = function () {
    customAjaxRequest('index.php?route=checkout/cart/removeCoupon', 'post', '', null, function (json) {
        location.reload();
    })
}

/**
 * Reîncarcă zona #cart și redeschide modalul de coș.
 *
 * DE CE E NEVOIE DE O FUNCȚIE, nu de două linii la fiecare apelant:
 * `#cartModal` se află ÎNĂUNTRUL lui `#cart` (common/cart.tpl include
 * cartModal.tpl), iar după fiecare adăugare reîncărcăm `#cart` prin AJAX ca să
 * se actualizeze contorul și conținutul modalului. Reload-ul distruge exact
 * elementul pe care Bootstrap îl gestionează: instanța veche rămâne legată de
 * un element detașat, iar backdrop-ul ei nu mai are cine să-l scoată.
 *
 * Măsurat pe xtdeco.ro, pagină de produs: prima adăugare — 1 backdrop, corect;
 * a doua — 2; după închiderea modalului rămânea 1 backdrop peste pagină, cu
 * overflow:hidden pe body. Ăsta e ecranul gri care blochează totul.
 *
 * Deci: aruncăm instanța CÂT elementul mai e în DOM (după reload nu mai e
 * accesibilă prin getInstance și ar rămâne cu ascultători pe document), iar
 * după reload curățăm ce a mai rămas — inclusiv backdrop-uri orfane dintr-o
 * adăugare anterioară, la utilizatorii care au deja pagina deschisă.
 */
window.reloadCartAndShowModal = function () {
    var oldEl = document.getElementById('cartModal');
    if (oldEl && window.bootstrap && window.bootstrap.Modal) {
        var prev = window.bootstrap.Modal.getInstance(oldEl);
        if (prev) { prev.dispose(); }
    }
    // Contextul de stivuire creat de wrapperul mmenu — din cauza căruia
    // backdrop-ul acoperea modalul — se neutralizează acum din CSS, în
    // common/mobile_menu.tpl (regula `body.modal-open .mm-slideout`). Aici nu
    // mai mutăm nimic în DOM; modalul rămâne unde îl pune șablonul.

    window.jQuery('#cart').load('index.php?route=common/cart/info #cart > *', function () {
        setTimeout(function () {
            var stray = document.querySelectorAll('.modal-backdrop');
            for (var i = 0; i < stray.length; i++) { stray[i].remove(); }
            document.body.classList.remove('modal-open');
            document.body.style.removeProperty('overflow');
            document.body.style.removeProperty('padding-right');

            var el = document.getElementById('cartModal');
            if (!el || !window.bootstrap || !window.bootstrap.Modal) { return; }

            if (typeof window.initCartModalUpsells === 'function') {
                window.initCartModalUpsells();
            }
            window.bootstrap.Modal.getOrCreateInstance(el).show();
        }, 500);
    });
};

window.productCartAddList = function (product_id = 0) {
    data = {};
    data['product_id'] = product_id;
    customAjaxRequest('index.php?route=checkout/cart/add', 'post', data, function () {
    }, function (json) {
        if (typeof timer != 'undefined') {
            clearTimeout(timer);
        }
        $('.alert, .invalid-feedback').remove();
        $('.is-invalid').removeClass('is-invalid');

        if (json['error']) {
            if (json['redirect']) {
                location = json['redirect'];
            }

            if (json['error']['quantity']) {
                alertMessage('pink-dark', 'exclamation-circle', json['error']['quantity'])
            }
        }

        if (json['success']) {
            window.reloadCartAndShowModal();
        }
        // window.: an undeclared timer = ... throws "timer is not defined" in the strict-mode bundle (2026-11-01)
        window.timer = setTimeout(function () {
            $('.alert').addClass('fadeOut');
        }, 4000)
    });
}

$(document).ready(function () {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

    const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
    const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl))

    const dropdownElementList = document.querySelectorAll('[data-bs-toggle="dropdown"]')
    const dropdownList = [...dropdownElementList].map(dropdownToggleEl => new bootstrap.Dropdown(dropdownToggleEl))

    const collapseElementList = document.querySelectorAll('[data-bs-toggle="collapse"]')
    const collapseList = [...collapseElementList].map(collapseToggleEl => new bootstrap.Collapse(collapseToggleEl))

    megaMenu();
    footerMenu();
    mobileColumnLeft();


    $(document).on('click', 'button[id^=\'button-upload\']', function () {
        var node = this;
        $('#form-upload').remove();
        $('body').prepend('<form enctype="multipart/form-data" id="form-upload" style="display: none;"><input type="file" name="file" /></form>');
        $('#form-upload input[name=\'file\']').trigger('click');
        if (typeof timer != 'undefined') {
            clearInterval(timer);
        }
        // window.: an undeclared timer = ... throws "timer is not defined" in the strict-mode bundle (2026-11-01)
        window.timer = setInterval(function () {
            if ($('#form-upload input[name=\'file\']').val() != '') {
                clearInterval(timer);
                $.ajax({
                    url: 'index.php?route=tool/upload',
                    type: 'post',
                    dataType: 'json',
                    data: new FormData($('#form-upload')[0]),
                    cache: false,
                    contentType: false,
                    processData: false,
                    beforeSend: function () {
                    },
                    complete: function () {
                    },
                    success: function (json) {
                        $('.text-red').remove();

                        if (json['error']) {
                            $(node).parent().find('input').after('<div class="text-red">' + json['error'] + '</div>');
                        }
                        if (json['success']) {
                            alert(json['success']);

                            $(node).parent().find('input').attr('value', json['code']);

                            $(node).addClass('btn-pink').removeClass('btn-cyan');
                        }
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
                    }
                });
            }
        }, 500);
    });
});
